import Select from './src/select.mjs';
export { selectV2InjectionKey } from './src/token.mjs';

Select.install = (app) => {
  app.component(Select.name, Select);
};
const _Select = Select;
const ElSelectV2 = _Select;

export { ElSelectV2, _Select as default };
//# sourceMappingURL=index.mjs.map
